<template>
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-10 pr-3 pl-3" v-else-if="!ajaxCallInProgress">
            <!-- Breadcrumb section -->
            <div class="row">
                <div class="col-lg-10 col-md-8 col-sm-8 col-xs-12">
                    <div class="breadcrumbnew">
                        <span>
                            <router-link to="/" class="text-white pl-2 text-line">Dashboard</router-link>
                        </span>
                    </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 mt-3">
                    <button class="btn btn-des-small ml-2 mr-2 float-right text-white"
                        @click="$router.push('/surveyform/create')" style="background:#128807; ">+
                        Create New Survey</button>
                </div>

            </div>

            <div class="row">
                <!-- Ongoing Survey Details Section -->
                <div class="col-lg-6 col-sm-12 col-md-6 p-2 pl-4">
                    <fullscreen ref="survey" @change="dataChange('survey')" class="bg-white box-radius">
                        <div class="card-item bg-white text-auto">
                            <div class="d-flex justify-content-between aling-items-center mt-2">
                                <div class="fw-500 mt-1 fs-14">Ongoing survey details</div>
                                <div class="d-flex ml-2 ">
                                <div class="d-flex ml-2 " style="flex-grow: 1;border: 1px solid #ccc !important; border-radius: 16px !important;height: 28px !important;width: 210px !important;">
                                    <!-- <div style="border: 1px solid #ccc !important; border-radius: 12px !important;"> -->
                                        <i class="icon icon-magnify icon-default-board search-height" style="background-color: #fff !important;"></i>
                                        <input class="w-100 dashboard-placeholder-text searchText search-height" type="text"
                                            v-model="search_key" @input="searchSurvey" placeholder="Search" style="background-color: #fff !important;">
                                    <!-- </div> -->
                                </div>
                                <button type="button" class="pointer bg-white icon-outline-css ml-3"
                                    @click="expandData('survey'), addClass()"><img class="expand-img"
                                        src="/static/images/exapand.svg" alt style="width: 20px !important" />
                                </button></div>
                            </div>
                            <div class="row mt-5" id="survey_response_div">
                                <div class="col-lg-12">
                                    <div class="w-100 mt-10" v-if="ajaxCallInProgressSurvey && !survey_details.length">
                                        <div class="d-flex align-items-center justify-content-center w-100" style="height: 200px;"
                                            v-if="ajaxCallInProgressSurvey">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                    </div>
                                    <div v-else-if="!ajaxCallInProgressSurvey && survey_details.length == 0"
                                        class="data-found mt-3">
                                        <img src="/static/images/ongoing_survey.png" class="mb-3 data-text" />
                                        <div class="text-center mt-10 text-muted fw-500">No ongoing survey details!</div>
                                    </div>
                                    <div v-else class="row">
                                        <div class="col-lg-6 col-sm-12 col-md-6 px-3 pb-3"
                                            v-for="(survey,index) in survey_details" :key="index">
                                            <div class="widget widget2 survey-cards card-item bg-white text-auto">
                                                <div class="fw-600 text-center fs-12 d-flex pt-1 pb-1">
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-5 div-spacing">Survey
                                                        Name</span>
                                                    <span class="mx-1">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-7 div-spacing text-truncate" style="max-width: 140px !important;" :title="survey.title">{{survey.title || '-'}}</span>
                                                </div>
                                                <div class="fw-600 text-center fs-12 d-flex pt-1 pb-1">
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-5 div-spacing">Product</span>
                                                    <span class="mx-1">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-7 div-spacing text-truncate" style="max-width: 140px !important;" :title="survey.product_name">{{survey.product_name || '-'}}</span>
                                                </div>
                                                <div class="fw-600 text-center fs-12 d-flex pt-1 pb-1">
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-5 div-spacing">Response</span>
                                                    <span class="mx-1">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-7 div-spacing">{{survey.responses || '-'}}</span>
                                                </div>
                                                <div class="fw-600 text-center fs-12 d-flex pt-1 pb-1">
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-5 div-spacing">Closure
                                                        Date</span>
                                                    <span class="mx-1">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-12 col-lg-7 div-spacing">{{convertViewSurvey(survey.end_date)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Survey Response Section -->
                <div class="col-lg-6 col-sm-12 col-md-6 p-2 pr-4">
                    <fullscreen ref="response" @change="dataChange('response')" class="bg-white box-radius">
                        <div class="card-item bg-white text-auto">
                            <div class="d-flex justify-content-between aline-items-center mt-2">
                                <div class="fw-500 fs-14">Survey Responses
                                    <el-select v-model="source" class="ml-1 fw-600 survey-response-dropdown drop-data" @change="sourceChange()"
                                        :popper-append-to-body="false">
                                        <el-option v-for="(time, index) in lead_source_options" :key="index"
                                            :label="time" :value="time">
                                        </el-option>
                                    </el-select>
                                </div>
                                <button type="button" class="pointer bg-white icon-outline-css mb-2"
                                    @click="expandData('response'), addClass()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt style="width: 20px !important"/>
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadSurveyResponsesSection" style="height: 317px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12 text-center" id="wrapper">
                                    <div id="responseDiv" class="mt-3"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
            <div class="row">
                <!-- Survey Based on Industry Type Section -->
                <div class="col-lg-7 col-sm-12 col-md-7 p-2 pl-4 ">
                    <fullscreen ref="industry" class="bg-white box-radius" @change="dataChange('industry')">
                        <div class="card-item bg-white text-auto">
                            <div class="d-flex justify-content-between aline-items-center mt-2">
                                <div class="fw-500 fs-14">Survey based on Industry type</div>
                                <button type="button" class="pointer bg-white icon-outline-css"
                                    @click="expandData('industry'), addClass()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt style="width: 20px !important"/>
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadSurveyIndustryTypeSection" style="height: 334px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div id="industryDiv" class="mt-3 fs-12"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Survey based on survey type Section -->
                <div class="col-lg-5 col-sm-12 col-md-5 p-2 pr-4">
                    <fullscreen ref="surveytype" class="bg-white box-radius" @change="dataChange('surveytype')">
                        <div class="card-item bg-white text-auto pb-0 ">
                            <div class="d-flex justify-content-between aline-items-center mt-2">
                                <div class="fw-500 fs-14">Survey based on Survey type</div>
                                <button type="button" class="pointer bg-white icon-outline-css"
                                    @click="expandData('surveytype'), addClass()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt style="width: 20px !important"/>
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadSurveyTypeSection" style="height: 350px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12" id="mainDiv">
                                    <div id="surveyTypeDiv" class="mt-3 fs-12"></div>
                                    <div id="legenddiv" style="height:50px"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>
<script>
    import dashboard from '../mixins/dashboard'
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import convert from '../mixins/convert'
    import {
        debounce
    } from 'lodash';
    export default {
        data() {
            return {
                loadSurveyTypeSection: false,
                loadSurveyIndustryTypeSection: false,
                loadSurveyResponsesSection: false,
                ajaxCallInProgress: false,
                ajaxCallInProgressSurvey: false,
                chart: {},
                response_data: [],
                scale_data: [],
                search_key: '',
                source: 'January 2023',
                time_period: 'FiscalYear',
                lead_source_options: ['January 2023', 'February 2023', 'March 2023', 'April 2023', 'May 2023',
                    'June 2023', 'July 2023', 'August 2023', 'September 2023', 'October 2023', 'November 2023',
                    'December 2023'
                ],
                period_options: ['FiscalYear', 'Semi-Annual', 'Quarter', 'Month'],
                warning_msg: '',
                success_msg: '',
                analytics_data: [],
                count: '',
                survey_data: [],
                skip: 0,
                limit: 10,
                search_key: '',
                survey_details: [],
                end_date: ''
            }
        },
        components: {
            SweetModal,
            HalfCircleSpinner
        },
        mixins: [dashboard, convert],
        methods: {
            //Api call to search the survey data
            searchSurveyDobouncer() {
                this.skip = 0;
                this.survey_details = [],
                    this.getSurveyDetails()
            },
            handleChange(value, type) {
                if (type === 'second') {
                    this.open = false;
                }
            },
            //if data change then load survey response api
            sourceChange() {
                this.SurveyResponse()
            },
            //Api call to get the industry analytics
            async IndustryAnalytics() {
                this.loadSurveyIndustryTypeSection = true;
                let params = {
                    type: 'industry_type',
                }
                let response = await this.getIndustryAnalytics(params)
                this.count = response.count
                this.analytics_data = response.response
                let result = []
                for (const item of this.analytics_data) {
                    result.push({
                        industry_type: item.industry_type,
                        percentage: item.percentage
                    });
                }
                this.analytics_data = result
                /**set the css class for the expand screen */
                if (this.analytics_data == '') {
                    this.loadSurveyIndustryTypeSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.analysisCss {width: 270px !important;height: 250px!important;margin: auto !important;margin-top:30px !important; }';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('industryDiv').innerHTML =
                            "<div class=text-center><img id= data-img src=/static/images/industry-type-survey.png class=mt-3><div class='mt-4 text-muted fw-500'>No Industry based Survey added!</div></div>";
                        document.getElementById('data-img').className = 'analysisCss';
                    }, 1000);
                } else {
                    this.loadSurveyIndustryTypeSection = false;
                    this.loadSurveyIndustryData()
                }
                this.loadSurveyIndustryTypeSection = false;
            },
            async loadSurveyIndustryData() {
                setTimeout(() => {
                    let vueThis = this
                    // Create chart instance
                    var chart = am4core.create("industryDiv", am4charts.PieChart);

                    // Add data
                    chart.data = vueThis.analytics_data

                    // Add label
                    chart.innerRadius = 60;

                    var label = chart.seriesContainer.createChild(am4core.Label);
                    label.text = vueThis.count;
                    label.horizontalCenter = "middle";
                    label.verticalCenter = "middle";
                    label.fontSize = 30;
                    label.truncate = true;
                    // Add and configure Series
                    var pieSeries = chart.series.push(new am4charts.PieSeries());
                    pieSeries.dataFields.value = "percentage";
                    pieSeries.dataFields.category = "industry_type";
                    pieSeries.labels.template.maxWidth = 200;
                    pieSeries.labels.template.wrap = true;

                    // Animate chart data
                    var count = vueThis.count;
                }, 1000);
            },
            //Get the survey response data
            async SurveyResponse() {
                this.loadSurveyResponsesSection = true;
                let data = this.source.split(' ')
                /**@params = month */
                let params = {
                    month: data[0]
                }
                let response = await this.getSurveyResponse(params)
                this.response_data = response.response
                let result = []
                let result1 = []
                let survey_repsonse = this.response_data.surveys
                for (const survey of survey_repsonse) {
                    result.push({
                        title: survey.title,
                        count: survey.count
                    });
                }
                for (const scale in survey_repsonse) {
                    result.scale = scale
                }
                this.response_data = result
                if (this.response_data == '') {
                    this.loadSurveyResponsesSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.dataCss {width: 250px !important;height: 230px!important;margin: auto !important;margin-top:20px !important;  }';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('responseDiv').innerHTML =
                            "<div class=text-center><img id= survey-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No survey responses added!</div></div>";
                        document.getElementById('survey-img').className = 'dataCss';
                    }, 1000);
                } else {
                    this.loadSurveyResponsesSection = false;
                    this.loadSurveyResponse()
                }
                this.loadSurveyResponsesSection = false;
            },
            //Api call to get the survey response and set it into the chart
            loadSurveyResponse() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("responseDiv", am4charts.XYChart);
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                    chart.data = vueThis.response_data
                    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.renderer.labels.template.horizontalCenter = "right";
                    categoryAxis.renderer.labels.template.verticalCenter = "middle";
                    categoryAxis.renderer.labels.template.rotation = 270;
                    categoryAxis.renderer.grid.template.strokeWidth = 0;
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.dataFields.category = "title";
                    categoryAxis.renderer.minGridDistance = 10;
                    categoryAxis.fontSize = 12;
                    categoryAxis.fontWeight = 500;
                    categoryAxis.renderer.labels.template.dy = 5;
                    categoryAxis.title.text = "Surveys"
                    categoryAxis.title.fontWeight = 600;
                    categoryAxis.title.fontSize = 14

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.min = 0;
                    valueAxis.fontSize = 12;
                    valueAxis.fontWeight = 500;
                    valueAxis.renderer.minGridDistance = 40;
                    valueAxis.renderer.baseGrid.disabled = true;
                    valueAxis.min = 0;
                    valueAxis.max = chart.data.scale;
                    valueAxis.strictMinMax = true;
                    valueAxis.title.text = "Response"
                    valueAxis.title.fontWeight = 600;
                    valueAxis.title.fontSize = 14
                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.categoryX = "title";
                    series.dataFields.valueY = "count";
                    series.columns.template.tooltipText = "{valueY.value}";
                    series.columns.template.tooltipY = 0;
                    series.columns.template.strokeOpacity = 0;
                    series.columns.template.adapter.add("fill", function (fill, target) {
                        return chart.colors.getIndex(target.dataItem.index);
                    });
                    var valueLabel = series.bullets.push(new am4charts.LabelBullet());
                    valueLabel.label.text = "{count}";
                    valueLabel.label.fontSize = 12;
                    valueLabel.label.fontWeight = 600;
                    valueLabel.label.horizontalCenter = "top";
                    valueLabel.label.verticalCenter = "top";
                    valueLabel.label.fill = am4core.color("#ffffff");
                }, 1000);
            },
            //Api call to get the survey analytics
            async SurveyAnalytics() {
                this.loadSurveyTypeSection = true;
                let params = {
                    type: 'survey_type',
                }
                let response = await this.getSurveyAnalytics(params)
                this.count = response.count
                this.survey_type_data = response.response
                let result = []
                for (const item of this.survey_type_data) {
                    result.push({
                        survey_type_name: item.survey_type_name,
                        percentage: item.percentage
                    });
                }
                this.survey_type_data = result
                if (this.survey_type_data == '') {
                    this.loadSurveyTypeSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.surveyTypeCss {width: 270px !important;height: 250px!important;margin: auto !important;margin-top:30px !important;  }';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('surveyTypeDiv').innerHTML =
                            "<div class=text-center><img id= type-img src=/static/images/survey-type.png class=mt-3><div class='mt-4 text-muted fw-500'>No Surveys added!</div></div>";
                        document.getElementById('type-img').className = 'surveyTypeCss';
                    }, 1000);
                } else {
                    this.loadSurveyTypeSection = false;
                    this.loadSurveyType()
                }
                this.loadSurveyTypeSection = false;
            },
            //set teh survey type data into the chart
            loadSurveyType() {
                setTimeout(() => {
                    let vueThis = this
                    var container = am4core.create("surveyTypeDiv", am4core.Container);
                    container.width = am4core.percent(70);
                    container.height = am4core.percent(80);
                    container.align = "right";
                    container.valign = "middle";
                    container.layout = "horizontal";
                    var chart = container.createChild(am4charts.PieChart);
                    // Add data
                    chart.data = vueThis.survey_type_data
                    chart.legend = new am4charts.Legend();
                    var legendContainer = am4core.create("legenddiv", am4core.Container);
                    legendContainer.width = am4core.percent(100);
                    legendContainer.height = am4core.percent(100);
                    chart.legend.parent = legendContainer;
                    chart.legend.position = "bottom";
                    chart.legend.layout = "horizontal"
                    chart.legend.contentAlign = "right"
                    chart.legend.align = "right";
                    chart.legend.valueLabels.template.disabled = "true";
                    chart.legend.valign = "bottom";
                    // Add and configure Series
                    var pieSeries = chart.series.push(new am4charts.PieSeries());
                    pieSeries.dataFields.value = "percentage";
                    pieSeries.dataFields.category = "survey_type_name";

                    pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;
                    //pieSeries.labels.template.text = "{category}\n{value.percent.formatNumber('#.#')}%";
                    pieSeries.labels.template.wrap = true;


                    var chart2 = container.createChild(am4charts.PieChart);
                    chart2.width = am4core.percent(30);
                    chart2.radius = am4core.percent(80);
                    // Add and configure Series
                    var pieSeries2 = chart2.series.push(new am4charts.PieSeries());
                    pieSeries2.dataFields.value = "percentage";
                    pieSeries2.labels.template.maxWidth = 100;
                    pieSeries2.labels.template.wrap = true;
                    pieSeries2.dataFields.category = "survey_type_name";
                    pieSeries2.slices.template.states.getKey("active").properties.shiftRadius = 0;
                    pieSeries2.labels.template.disabled = true;
                    pieSeries2.ticks.template.disabled = true;
                    pieSeries2.alignLabels = false;

                    chart.events.on("datavalidated", function () {
                        setTimeout(function () {
                            //selectSlice(pieSeries.dataItems.getIndex(0));
                        }, 1000);
                    });
                }, 1000);
            },
            //Api call to get the surey details
            async getSurveyDetails() {
                this.ajaxCallInProgressSurvey = true;
                this.survey_details = [];
                this.check_all = false;
                this.survey_form_selected = [];
                /**@params = skip, @params= limit, @params = search */
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit == "" || this.limit == null || this.limit == undefined || this
                            .limit == 0 || this.limit < 0 ? 10 : this.limit,
                        search: this.search_key
                    }
                    let response = await this.getOngoingSurvey(params);
                    this.survey_details = response.response.forms;
                    this.total = response.count;
                } catch (error) {
                    this.warning_msg = error
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
                this.ajaxCallInProgressSurvey = false;

            },
            //expand to full screen
            /**@params = value */
            expandData(value) {
                if (value == 'surveytype') {
                    this.$refs["surveytype"].toggle();
                    this.addClass()
                } else if (value == 'industry') {
                    this.$refs["industry"].toggle();
                    this.addClass()
                } else if (value == 'response') {
                    this.$refs["response"].toggle();
                    this.addClass()
                } else if (value == 'survey') {
                    this.$refs["survey"].toggle();
                    this.addClass()
                }
            },
            //change the data
            /**@params = value */
            dataChange(value) {
                if (value == 'surveytype') {
                    this.surveytype = value;
                    this.addClass()
                } else if (value == 'industry') {
                    this.industry = value;
                    this.addClass()
                } else if (value == 'response') {
                    this.response = value;
                    this.addClass()
                } else if (value == 'survey') {
                    this.survey = value;
                    this.addClass()
                }
            },
            //add the classes to expand the div size in full screen
            addClass() {
                var response = document.getElementById('responseDiv');
                response.classList.toggle('responseDiv-expand');
                var industry = document.getElementById('industryDiv');
                industry.classList.toggle('industryDiv-expand');
                var surveyType = document.getElementById('surveyTypeDiv');
                surveyType.classList.toggle('surveyTypeDiv-expand');
                var survey = document.getElementById('survey_response_div');
                survey.classList.toggle('survey_response_div_expand');
            },
        },
        created() {
            this.searchSurvey = debounce(this.searchSurveyDobouncer, 500)
        },
        watch: {
            selected_type() {
                if (this.selected_type == 'month') {
                    this.open = true
                } else {
                    this.open = false
                }
            }
        },
        async mounted() {
            this.IndustryAnalytics()
            this.SurveyAnalytics(),
            this.SurveyResponse()
            this.getSurveyDetails()

        }
    }
</script>
<style scoped>
    .w-50 {
        width: 50%;
    }

    .hello {
        width: 100%;
        height: 500px;
    }

    .card-item {
        padding: 18px;
        border-radius: 6px;
    }

    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }

    .ml-32px {
        margin-left: 32px;
    }

    #industryDiv {
        width: 100%;
        height: 320px;
    }

    #convertedLeadDiv {
        width: 100%;
        height: 270px;
    }

    #contractDiv {
        width: 100%;
        height: 340px;
    }

    #campaignDiv {
        width: 100%;
        height: 340px;
    }

    #targetDiv {
        width: 100%;
        height: 340px;
    }

    #responseDiv {
        width: 100%;
        height: 305px;
    }

    .logo-image {
        width: 40px;
        height: 55px;
    }

    .contracts-logo {
        position: relative;
        bottom: 20px;
    }

    .pb-10px {
        padding-bottom: 10px;
    }

    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }

    .meetings {
        border: 1px solid #005dae;
        border-radius: 4px;
        padding-top: 8px;
    }

    #targetachievedDiv {
        width: 100%;
        height: 300px;
    }

    #surveyTypeDiv {
        width: 100%;
        height: 288px;
        margin-left: -24px;
    }

    #salesValue {
        width: 100%;
        height: 340px;
    }

    .text-rotate {
        transform: rotate(-90deg);
        position: relative;
        right: 316px;
        top: 150px;
    }

    .table-properties {
        border-collapse: collapse;
        width: 100%;
    }

    table thead th,
    table tbody td {
        padding: 10px;
    }

    #days {
        cursor: pointer;
    }

    .expand-img {
        width: 18px;
        margin-bottom: 2px;
    }

    .today-meetings {
        min-height: 377px;
        max-height: 377px;
        overflow: auto;
    }

    .icon-images {
        width: 24px;
        padding-right: 10px;
    }

    .copy-icon-images {
        width: 30px;
    }

    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 200px
    }

    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;
    }

    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }

    .contactMedia {
        width: 100%;
        height: 280px !important;
    }

    .new-blue {
        color: #00448b !important;
    }

    .slant-tabs {
        position: relative;
        height: 40px;
        min-width: 100px !important;
        text-align: center;
        line-height: 44px;
        color: #7b7f97;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .new-blue {
        background-color: #e5eaed
    }

    .icon-default-board {
        border-radius: 20px 0px 0px 20px;
        color: #00448b;
        width: 30px;
        font-size: 14px;
        padding: 2px;
        background: #ddd !important;
        border-color: #ddd !important;
        height: 30px !important;
        padding: 1px 16px;

    }

    .searchText {
        border-radius: 0px 20px 20px 0px !important;
        padding-left: 10px;
        background-color: #ddd;
        width: 100% !important;
    }

    .survey-cards {
        border: 1px solid #7faed6;
        padding: 10px !important
    }

    #survey_response_div {
        min-height: 305px;
        max-height: 305px;
        overflow: scroll;
    }

    .div-spacing {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .data-found {
        text-align: center !important;
        margin: auto;
        margin-top: 20px !important;
    }

    .box-radius {
        border-radius: 7px !important;
    }

    .search-height {
        height: 25px !important
    }

    .drop-data {
        border-radius: 6px;
        border: 0.6px solid #7faed6 !important;
    }

    .industryDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 90
    }

    .surveyTypeDiv-expand,
    .responseDiv-expand,
    .surveTypeDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 90
    }

    .survey_response_div_expand {
        min-height: 700px !important;
        max-height: 700px !important;
        overflow: scroll !important;
        margin: auto;
        vertical-align: middle;

    }

    .data-text {
        width: 65% !important;
        height: auto;
        margin: auto !important;
        margin-top: 20px
    }

    .el-select.drop-data .el-input__icon {
        line-height: 0px !important
    }
    .btn-des-small{
        padding: 0px 20px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/SurveyDashboard.vue